import React from "react";
export default function Projects() {
    return (
        <section id="open-source">
            <header className="section-header">
                <h2>Recent Client Projects</h2>
            </header>
            <div className="section-content">
                <table>
                    <thead>
                        <tr>
                            <th>Project Name</th>
                            <th>Site Generator</th>
                            <th>CMS</th>
                            <th>Live Site</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Colladeo Website</td>
                            <td>Eleventy</td>
                            <td>x</td>
                            <td><a href="https://colladeo.com" target="_blank" rel="noopener noreferrer">https://colladeo.com</a></td>
                            <td>Fully custom HTML and CSS from the original Figma design, integrated into a ready-to-deploy Eleventy project.</td>
                        </tr>
                    </tbody>
                    <tbody>
                        <tr>
                            <td>Shotsy App Website</td>
                            <td>Jekyll</td>
                            <td>yaml data</td>
                            <td><a href="https://shotsyapp.com" target="_blank" rel="noopener noreferrer">https://shotsyapp.com</a></td>
                            <td>Fully custom HTML and CSS from the original Figma design, integrated into a ready-to-deploy Jekyll project.</td>
                        </tr>
                    </tbody>
                    <tbody>
                        <tr>
                            <td>JamComments UI</td>
                            <td>x</td>
                            <td>x</td>
                            <td><a href="https://gregarious-semifreddo-75081e.netlify.app" target="_blank" rel="noopener noreferrer">View the DEMO</a></td>
                            <td>Implementation of a design provided in Adobe XD, rendered in custom HTML, CSS, and JS. The final SaaS application has not yet launched.</td>
                        </tr>
                    </tbody>
                    <tbody>
                        <tr>
                            <td>How to Hi-Fi</td>
                            <td>Jekyll</td>
                            <td>Netlify CMS</td>
                            <td><a href="https://howtohifi.com" target="_blank" rel="noopener noreferrer">https://howtohifi.com</a></td>
                            <td>A Jekyll blog using <a href="https://picocss.com/" target="_blank" rel="noopener noreferrer">Pico.css</a> for base styles, customized where needed, and a custom configuration of Netlify CMS developed and implemented for content management. Built for SEO and Performance.</td>
                        </tr>
                    </tbody>
                    <tbody>
                        <tr>
                            <td>Stargazer Equestrian</td>
                            <td>Jekyll</td>
                            <td>Netlify CMS</td>
                            <td><a href="https://stargazerequestrian.com" target="_blank" rel="noopener noreferrer">https://stargazerequestrian.com</a></td>
                            <td>A Jekyll E-Commerce site using Snipcart and a custom configuration of Netlify CMS. No design was provided so I used <a href="https://github.com/discoform/shapes-for-jekyll-and-snipcart" target="_blank" rel="noopener noreferrer">my own custom Jekyll x Snipcart starter</a>.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <header className="section-header">
                <h2>Recent Open Source Projects</h2>
                <p>We've built several HTML templates and starter themes for a variety of Static Site solutions. Many of them are now <a href="https://github.com/discoform" target="_blank" rel="noopener noreferrer" title="Connect with discoform on GitHub">open-sourced and available from our GitHub portfolio</a>.</p>
            </header>
            <div className="section-content">
                <table>
                    <thead>
                        <tr>
                            <th>Project Name</th>
                            <th>Site Generator</th>
                            <th>CMS</th>
                            <th>Live Demo</th>
                            <th>GitHub Repo</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Rubik for Jekyll</td>
                            <td>Jekyll</td>
                            <td>x</td>
                            <td><a href="https://discoform-rubik.netlify.app" target="_blank" rel="noopener noreferrer">https://discoform-rubik.netlify.app</a></td>
                            <td><a href="https://github.com/discoform/rubik-for-jekyll" target="_blank" rel="noopener noreferrer">https://github.com/discoform/rubik-for-jekyll</a></td>
                        </tr>
                        <tr>
                            <td>Numberzs</td>
                            <td>Jekyll</td>
                            <td>Netlify CMS</td>
                            <td><a href="https://numberzs.com" target="_blank" rel="noopener noreferrer">https://numberzs.com</a></td>
                            <td><a href="https://github.com/discoform/numberzs" target="_blank" rel="noopener noreferrer">https://github.com/discoform/numberzs</a></td>
                        </tr>
                        <tr>
                            <td>Nightwatch</td>
                            <td>x</td>
                            <td>x</td>
                            <td><a href="https://nightwatch-theme.netlify.app" target="_blank" rel="noopener noreferrer">https://nightwatch-theme.netlify.app</a></td>
                            <td><a href="https://github.com/discoform/nightwatch" target="_blank" rel="noopener noreferrer">https://github.com/discoform/nightwatch</a></td>
                        </tr>
                        <tr>
                            <td>Shapes For Jekyll and Snipcart</td>
                            <td>Jekyll</td>
                            <td>x</td>
                            <td><a href="https://shapes-for-jekyll-and-snipcart.netlify.app" target="_blank" rel="noopener noreferrer">https://shapes-for-jekyll-and-snipcart.netlify.app</a></td>
                            <td><a href="https://github.com/discoform/shapes-for-jekyll-and-snipcart" target="_blank" rel="noopener noreferrer">https://github.com/discoform/shapes-for-jekyll-and-snipcart</a></td>
                        </tr>
                        <tr>
                            <td>Point Zero</td>
                            <td>Jekyll</td>
                            <td>Netlify CMS</td>
                            <td><a href="https://point-zero.netlify.app" target="_blank" rel="noopener noreferrer">https://point-zero.netlify.app</a></td>
                            <td><a href="https://github.com/discoform/point-zero" target="_blank" rel="noopener noreferrer">https://github.com/discoform/point-zero</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
    );
}


// WEBPACK FOOTER //
// ./src/components/Projects.js